// Two views of one drawing.
//
// Portrait art ships as a 3:4 full-page drawing: a full-body figure on visible paper, with
// margins, a flat tribe-coloured block and the occasional pen mark. That page is the whole point
// in a lightbox — it is the piece of art — and it is the wrong asset for a ~200px tile, where the
// figure is thumbnail-sized and the face that actually identifies the character is barely 20px
// across.
//
// So a square "bust" derivative is built alongside it (tools/build-portrait-busts.py), cropped to
// head-and-shoulders with the crop position DETECTED per drawing rather than fixed — a fixed crop
// breaks as soon as a figure is not standing, and one of them crouches.
//
//   in-game tiles  -> bustPath()  square, ~32K, face reads at tile size
//   lightbox       -> the original path, unchanged
//
// Keep this the only place that knows the naming convention, so the build tool and the components
// cannot drift apart.

/**
 * Sibling bust for a portrait path.
 *
 *   "portraits/el_tagger.webp"  ->  "portraits/bust/el_tagger.webp"
 *
 * Callers should fall back to the original path if the bust 404s: art can land before the bust
 * step has been run, and a hero with a missing derivative should degrade to the full page rather
 * than to no portrait at all.
 */
export function bustPath(art: string): string {
  const slash = art.lastIndexOf('/');
  return slash === -1
    ? `bust/${art}`
    : `${art.slice(0, slash)}/bust/${art.slice(slash + 1)}`;
}
